import { render, staticRenderFns } from "./DueDate.vue?vue&type=template&id=de875dea&scoped=true"
import script from "./DueDate.vue?vue&type=script&lang=ts"
export * from "./DueDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de875dea",
  null
  
)

export default component.exports